import { showEnd } from '../store/mutation';

export const endLive = () => {
  showEnd();
};
